import { Component } from '@angular/core';
import { FloatingNotificationService } from './floating-notification.service';
import { AppNotification } from './floating-notification.model';
import { AsyncPipe } from "@angular/common";

@Component({
    selector: 'app-notification-container',
    templateUrl: './floating-notification-container.component.html',
    imports: [
    AsyncPipe
],
    styleUrls: ['./floating-notification-container.component.scss']
})
export class FloatingNotificationContainerComponent {

    notifications$ = this.notificationService.notifications$;

    constructor(private notificationService: FloatingNotificationService) {}

    close(notification: AppNotification) {
        if (notification.id) {
            this.notificationService.close(notification.id);
        }
    }
}